// extracted by mini-css-extract-plugin
export default {"header":"LiftingHeader_header__JeUdl","lifterName":"LiftingHeader_lifterName__4I9bN","info":"LiftingHeader_info__CJVXK"};